import { computed, type ComputedRef, type InjectionKey, provide, ref } from "vue";
import injectAsserted from "./assert/injectAsserted";

export const TimeZoneInjectionKey = Symbol("TimeZoneInjectionKey") as InjectionKey<
  ComputedRef<string>
>;

export function useTimeZoneProvide(value: ComputedRef<string | undefined | null>) {
  /**
   * move this inject inside a setup context
   * will remove warnings
   */
  const oldTZ = injectAsserted(TimeZoneInjectionKey);
  const tz = computed(() => value.value ?? oldTZ.value);
  return {
    provide: provide(TimeZoneInjectionKey, tz),
    tz,
  };
}

type SelectedSiteType = { id: number; name: string; tz: string };

/**
 * composable to provide timezone on preferredSiteSelect
 * @returns the functions that must be bind to preferredSiteSelect
 */
export function usePreferredSiteSelectTimezoneProvide() {
  const timezone = ref<string>();

  function onSiteSelectDataLoaded(data: { selected: SelectedSiteType }) {
    timezone.value = data.selected.tz;
  }

  function onElementSelected(site: SelectedSiteType) {
    timezone.value = site.tz;
  }

  const { tz } = useTimeZoneProvide(computed(() => timezone.value));

  return {
    onSiteSelectDataLoaded,
    onElementSelected,
    tz,
  };
}
